<script>
import dom from '@/assets/js/helper/dom'

let localUrls = []

export default {
  created () {
    localUrls = this.$store.getters['gui/getLocalUrls']
    window.addEventListener('click', event => handleClick.bind(this)(event))
  }
}

function handleClick (event) {
  const link = dom.getPath(event.target).find(element => element.href !== undefined)

  if (link) {
    const href = link.href || window.location.href
    const url = window.URL ? new URL(href) : { host: href.replace(/^(?:(?:(?:https?|ftp):)?\/\/)([^/?#]+)(?:[/?#].*)/gm, (m, $1) => $1) || window.location.host }

    if (url.host && !localUrls.includes(url.host)) {
      event.preventDefault()
      this.$root.$emit('externallinkmodal:show', href)
    }
  }
}
</script>
